export interface OrganizationDetails {
	id?: number;
	name: string;
	administratorId?: number;
	vatNumber: string;
	suppliers?: string;
	country?: string;
	address?: string;
	postCode?: string;
	city?: string;
	stateOrCounty?: string;
	administratorFirstName?: string;
	administratorSurname?: string;
	administratorEmail?: string;
}

export const EMPTY_ORGANIZATION: OrganizationDetails = {
	administratorId: 0,
	id: -1,
	name: '',
	vatNumber: '',
	suppliers: '',
	country: '',
	address: '',
	postCode: '',
	city: '',
	stateOrCounty: '',
	administratorFirstName: '',
	administratorSurname: '',
	administratorEmail: ''
};

interface OrganizationService {
	serviceCode: string;
	serviceLabel: string;
	serviceDescription: string;
}

interface OrganizationSupplierServices {
	supplierId: number;
	supplierName: string;
	services: OrganizationService[];
}
export interface OrganizationServices {
	supplierServices: OrganizationSupplierServices[];
}
interface OrganizationUser {
	userId: number;
	firstName: string;
	lastName: string;
	email: string;
	status: string;
	statusLabel: string;
	role: string;
	roleLabel: string;
}

export interface OrganizationUsers {
	users: OrganizationUser[];
}

export const ADMIN_USER_ROLE = 'dsu';
